<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigil_not_in_toc" style="text-align: center;">More from Henry Kuttner</h2>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/chap270022" title="Link target outside of Sample">The Time Trap<br/>
  Book of Iod<br/>
  Elak of Atlantis<br/>
  Prince Raynor<br/>
  Murder of Eleanor Pope<br/>
  Murder of a Mistress<br/>
  Murder of a Wife<br/>
  Murder of Ann Avery<br/>
  The Best of Henry Kuttner<br/>
  Robots Have No Tails<br/>
  Ahead of Time<br/>
  Earth’s Last Citadel<br/>
  Mask of Circe<br/>
  Man Drowning</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0f819e26